import React from "react";
import { Link } from "react-router-dom";

import { Message, Button } from "../../index";

export const InterviewFailed = () => {
    return (
        <div className="interview-failed-view container">
            <p>
                <Message code="errors.esport.prizes.generic.error" />
            </p>
            <div className="button-wrapper">
                <Button as={Link} to={{path: '/'}}>
                    <Message code="epic.common.back" />
                </Button>
            </div>
        </div>
    );
};
